import styled from 'styled-components'

export const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  margin-bottom: 24px;
`

export const SubscriptionBannerContainer = styled.div`
  margin-bottom: 24px;
`
